import React, { useCallback } from 'react';
import clsx from 'clsx';
import { StatsCard } from 'common/components';
import { useStyles } from 'features/command-center/components/shared';
import { COMMAND_CENTER_BASE_URL, ENDPOINTS, TABLES_KEYS } from 'features/command-center/constants';
import useDatatable, { getColumnPreferences, getColumnsToRender } from 'hooks/datatable';
import { SECONDARY_API_CLIENT } from 'services/API';
import strings from 'strings';
import DataTable from 'UI/components/organisms/DataTable';

import { WIDGETS } from '../../productionBoard.constants';
import { formatTrackingResponse } from '../../productionBoard.utils';

import { ORDER_BY_OPTIONS, PRODUCTION_TRACKING_COLUMNS } from './productionTracking.columns';
import { ProductionTrackingByRecruiter } from './ProductionTrackingByRecruiter';

const TABLE_KEY = TABLES_KEYS.productionBoardTracking;
const initialPreferences = getColumnPreferences(
  TABLE_KEY,
  0,
  ORDER_BY_OPTIONS,
  PRODUCTION_TRACKING_COLUMNS
);

export const ProductionTracking = ({ queryParams, onLoadWidgetData }) => {
  const classes = useStyles();

  const endpoint = `${COMMAND_CENTER_BASE_URL}/${ENDPOINTS.productionTrackingByTeam}?${queryParams}`;

  const handleFetchedData = useCallback(
    ({ data: { mtdTracking, ytdTracking } }) => {
      onLoadWidgetData({ [WIDGETS.mtdTracking]: mtdTracking, [WIDGETS.ytdTracking]: ytdTracking });
    },
    [onLoadWidgetData]
  );

  const { columnPreferences, data, listState, handleColumnSortChange } = useDatatable({
    key: TABLE_KEY,
    apiInstance: SECONDARY_API_CLIENT,
    columnsDefinitions: PRODUCTION_TRACKING_COLUMNS,
    endpoint,
    formatResponse: formatTrackingResponse,
    initialPreferences,
    onFetchedData: handleFetchedData,
    orderByOptions: ORDER_BY_OPTIONS
  });

  const { isLoading, showWholeSkeleton } = listState;
  const { columns, direction, orderBy } = columnPreferences;
  const finalColumns = getColumnsToRender(columns);
  const isEmpty = Array.isArray(data) && data.length === 0;

  return (
    <StatsCard header={strings.commandCenter.productionBoard.trackingProduction} paddingContent={0}>
      <DataTable
        className={clsx(classes.mediumWeightRow, {
          [classes.firstRow]: !isEmpty
        })}
        columns={finalColumns}
        components={{ TableToolbar: () => null }}
        data={data}
        elevation={0}
        expandableRows
        expandableRowsHeader={false}
        filter={false}
        isRowExpandable={() => true}
        loading={showWholeSkeleton}
        onColumnSortChange={handleColumnSortChange}
        refreshing={isLoading}
        rowsExpanded={[]}
        search={false}
        selectableRows="none"
        viewColumns={false}
        renderExpandableRow={rowData => {
          return (
            <ProductionTrackingByRecruiter
              columns={finalColumns}
              queryParams={`${queryParams}&orderBy=${orderBy}&direction=${direction}`}
              selectedTeam={rowData[0]}
            />
          );
        }}
      />
    </StatsCard>
  );
};
